import { LoadingSpinnerPageState } from '@/ui/composites/LoadingSpinnerPageState';
import type { ReactElement } from 'react';

type SettingsPageLoadingStateProps = {
  message: string;
};

export const SettingsPageLoadingState = ({
  message,
}: SettingsPageLoadingStateProps): ReactElement => <LoadingSpinnerPageState message={message} />;
